<script>
    import Util from "../../lib/util.js";
    import {onMount, onDestroy, getContext} from 'svelte';
    import { fade, fly } from 'svelte/transition';

    import HelperText from '@smui/textfield/helper-text/index';
    import FloatingLabel from '@smui/floating-label';

    export let outline = false;
    export let help = "";
    export let label = "";
    export let style;

    let id;
    let floatingLabelComponent;

    $: hasHelpText = !!help;

    onMount(() => {
        id = Util.randomHash();
        if (label) {
            floatingLabelComponent.float(true);
        }
    });
</script>

<div class="form-field" class:outline class:hasHelpText {style} {id} transition:fade>
    {#if label}
        <FloatingLabel
                for="{id}"
                bind:this={floatingLabelComponent}
                style="left: 15px; background: #FFF; padding: 0 5px;">
            {label}
        </FloatingLabel>
    {/if}
    <div class="inner" style="height: 100%;">
        <slot>
            <!-- yielded field content -->
        </slot>

        {#if help}
            <HelperText persistent>
                {help}
            </HelperText>
        {/if}
    </div>
</div>

<style>
    .form-field {
        margin-bottom: 25px;
        position: relative;
    }

    .form-field.outline {
        border: 1px solid #9e9e9e;
        border-radius: 5px;
    }

    .form-field.outline .inner {
        padding: 15px;
    }

    .form-field.hasHelpText {
        //margin-bottom: 45px;
    }

    :global(.form-field.hasHelpText > .mdc-text-field-helper-line) {
        position: absolute;
        bottom: -20px;
    }
</style>